import type { RootState } from 'state';
import type { DataAirportsState } from '../slice';

function getDataAirports(state: RootState): DataAirportsState['value'] {
  const { value } = state.dataService.airports.dataAirports;
  return value;
}

export default getDataAirports;